import { FC, ReactNode, ReactElement } from "react";
import { Tabs } from "antd";
import classnames from "classnames";

import styles from "./Tabs.module.scss";

const { TabPane } = Tabs;

export interface ITab {
  key: string;
  name: ReactElement | string;
  content: ReactNode | string;
  closable?: boolean;
  closeIcon?: ReactNode;
  render?: boolean;
  forceRender?: boolean;
  isError?: boolean;
  isIndexName?: boolean;
  [key: string]: any;
}

interface ITabsProps {
  className?: string;
  activeKey?: string | number;
  defaultActiveKey?: string | number;
  onChange?: (key) => void;
  onEdit?: (key, action) => void;
  onTabClick?: (key) => void;
  tabs: ITab[];
  editable?: boolean;
  hideAdd?: boolean;
  tabBarExtraContent?: ReactNode;
  destroyInactiveTabPane?: boolean;
  isErrorTabs?: boolean;
  countIndex?: number;
}

export const ITabs: FC<ITabsProps> = ({
  className,
  activeKey,
  defaultActiveKey,
  onChange,
  onEdit,
  onTabClick,
  tabs,
  editable,
  hideAdd,
  tabBarExtraContent,
  destroyInactiveTabPane = false,
  countIndex = 1,
  isErrorTabs, // включает подсветку красным табов с ошибками
}) => {
  const renderTabs = tabs.map((tab) => {
    return { render: true, ...tab };
  });

  return (
    <Tabs
      onChange={onChange}
      onEdit={onEdit}
      onTabClick={onTabClick}
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      className={classnames(styles.Tabs, {
        [className]: className,
        [styles.errorTabs]: isErrorTabs,
      })}
      type={editable ? "editable-card" : "card"}
      tabBarExtraContent={tabBarExtraContent}
      hideAdd={hideAdd}
      destroyInactiveTabPane={destroyInactiveTabPane}
    >
      {renderTabs
        .filter((tab) => tab.render)
        .map((tab, i) => (
          <TabPane
            tab={
              tab.isError ? (
                <div data-error="true">Проверьте корректность данных</div>
              ) : (
                tab?.isIndexName ? `${tab.name}${i + countIndex}` : tab.name
              )
            }
            key={tab.key}
            closable={tab.closable}
            closeIcon={tab.closeIcon}
            forceRender={tab.forceRender}
          >
            {tab.content}
          </TabPane>
        ))}
    </Tabs>
  );
};
